// extracted by mini-css-extract-plugin
module.exports = {"issue-Info":"FirstStep_issue-Info__13IPZ","first-step":"FirstStep_first-step__SEXhb","first-step__boxes":"FirstStep_first-step__boxes__1WuOr"};